module.exports = __webpack_public_path__ + "static/media/screenshot-4.ce4602bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/screenshot-4.png
// module id = 689
// module chunks = 2